/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import EditTutorialForm from '../forms/EditTutorialForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
const EditTutorialModal = ({ show, handleClose, currentPDF }) => {
  const formRef = useRef(null);

  const handleSave = e => {
    e.preventDefault();
    handleClose();
    {
      /*
    if (formRef.current) {
      formRef.current.submit();
    }*/
    }
  };
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EditTutorialForm
          ref={formRef}
          currentPDF={currentPDF}
          onSubmit={handleClose}
        />
      </Modal.Body>
      <Modal.Footer>
        <style>
          {`
      @media (max-width: 767px) {
        .button-container > .btn {
          width: 100%;
          margin-bottom: 10px;
        }

        .button-container > :nth-child(1) {
          order: 1;
        }
        .button-container > :nth-child(2) {
          order: 2;
        }
      }
    `}
        </style>

        <div
          className="d-flex flex-column-reverse flex-md-row justify-content-end button-container"
          style={{ gap: '1rem', width: '100%' }}
        >
          <Button variant="secondary" type="button" onClick={handleClose}>
            <FontAwesomeIcon icon="fa-xmark" style={{ marginRight: 5 }} />
            Cancelar
          </Button>
          <Button variant="success" type="submit" onClick={handleSave}>
            <FontAwesomeIcon icon="fa-check" style={{ marginRight: 5 }} />
            Guardar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTutorialModal;
